<template>
    <div class="column is-4-desktop">
        <form>
            <div class="field">
                <label class="label">Name</label>
                <div class="control has-icons-left" :class="{ 'is-loading': isLoading }">
                    <input
                            v-bind:disabled="!isAdmin && !isAffiliate"
                            v-model="user.name"
                            v-on:keyup="updateUser"
                            v-bind:class="{ 'is-danger': errors.name }"
                            class="input"
                            type="text"
                            placeholder="Enter name">
                    <span class="icon is-small is-left">
                        <i class="fas fa-user"></i>
                    </span>
                    <p v-if="errors.name" class="help is-danger">{{ errors.name[0] }}</p>
                </div>
            </div>
            <div class="field">
                <label class="label">Email</label>
                <div class="control has-icons-left" :class="{ 'is-loading': isLoading }">
                    <input v-bind:disabled="!isAdmin && !isAffiliate"
                           v-model="user.email"
                           v-on:keyup="updateUser"
                           v-bind:class="{ 'is-danger': errors.email }"
                           class="input"
                           type="email"
                           placeholder="Enter email">
                    <span class="icon is-small is-left">
                        <i class="fas fa-envelope"></i>
                    </span>
                    <p v-if="errors.email" class="help is-danger">{{ errors.email[0] }}</p>
                </div>
            </div>
            <div class="field" v-if="!isSalesStaff()">
                <label class="label">User Role</label>
                <div class="control has-icons-left">
                    <div class="select is-fullwidth" :class="{ 'is-loading': isLoading }">
                        <select v-bind:disabled="!isAdmin && !isAffiliate" v-model="user.role" v-on:change="updateUser">
                            <option v-for="role in roles">{{ role }}</option>
                        </select>
                    </div>
                    <span class="icon is-left">
                        <i class="fas fa-user-shield"></i>
                    </span>
                </div>
            </div>
            <user-login :user="user" v-if="!isSalesStaff()"></user-login>
            <transfer-user :user="user" v-if="!isSalesStaff()"></transfer-user>
            <transfer-user-modal :user="user" v-if="!isSalesStaff()"></transfer-user-modal>
        </form>
    </div>
</template>

<script>
    import UserLogin from './Inputs/UserLogin'
    import TransferUser from './Inputs/TransferUser'
    import apiUsers from '../../../api/apiUsers'
    import TransferUserModal from './Transfer/TransferUserModal'

    export default {
        components: {
            UserLogin,
            TransferUser,
            TransferUserModal
        },
        props: ['user'],
        data() {
            return {
                errors: {
                    name: '',
                    email: '',
                    role: ''
                },
                isLoading: false,
                roles: [
                    'Visitor',
                    'User',
                    'Affiliate',
                    'Manager',
                    'Admin',
                    'Deactivated',
                    'Overseas Manager',
                    'Sales Staff',
                    'Bidder',
                    'Supplier'
                ],
            }
        },
        methods: {
            updateUser() {
                setTimeout(() => {
                    this.isLoading = true;
                    apiUsers
                        .userUpdateRequest(this.$route.params.id, this.user)
                        .then((response) => {
                            if (response.status === 200) {
                                this.errors = {
                                    name: '',
                                    email: '',
                                    role: ''
                                }
                                this.isLoading = false;
                            }
                        })
                        .catch((err) => {
                            if (err.response.status === 422) {
                                this.errors = err.response.data.errors
                            }
                        })
                }, 1000)
            },
            isSalesStaff() {
                if (this.$store.getters.getUserRole === 'Sales Staff') {
                    return true
                }
            }
        },
        computed: {

            isAdmin() {
                if (this.$store.getters.getUserRole === 'Admin') {
                    return true
                }
            },
            isAffiliate() {
                if (this.$store.getters.getUserRole === 'Affiliate') {
                    return true
                }
            }
        }
    }
</script>

<style scoped>
    .fade-leave-active {
        transition: opacity .5s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
    {
        opacity: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/Users/User/UserEdit.vue